import React, {memo, useState, useEffect} from 'react';

//Component.
import VideoCardComponent from '../../card-component/video-card-component/VideoCardComponent';
import AllVideosComponent from '../../all-videos/AllVideosComponent';
import AddVideoToChallengeForm from './forms/addVideoToChallenge/AddVideoToChallengeForm';

//Dependencies.
import { useParams, Link, useNavigate } from 'react-router-dom';
import { Alert } from 'reactstrap';

//Functions.
  //Slices.
  import { useDispatch, useSelector } from 'react-redux';
  //Selectors.
  import { allUpcomingChallenges, challengesState, FStransferChallengeFromUpcomingToActive, transferChallenge } from '../../../slices/challengesSlice';
  import { loggedInUser } from '../../../slices/allUsersSlice';
  
import "./ChallengeAnnouncementDetails.styles.css";

const ChallengeAnnouncementDetails = () => {
  const [addMoreVideos, setAddMoreVideos] = useState(false);
  const [challengeVideosCount, setchallengeVideosCount] = useState(0);
  const currentUser = useSelector(loggedInUser);
  const loadingStatus = useSelector(challengesState).isLoading;
  const params = useParams();

  const { _challengeID } = params;
  const announcementDetails = useSelector(allUpcomingChallenges)[_challengeID];

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const initialChallengeVideosCount = Object.values(announcementDetails?.challengeVideos)?.length;

    setchallengeVideosCount(initialChallengeVideosCount);

    return () => {
      setAddMoreVideos(false); //Reset add more videos to false after leaving.
    };
  }, []);

  if (announcementDetails) {
    const {
      _ownerID,
      coverImageDetails: { imageLink },
      challengeVideos,
      upcomingChallengeProperties: {
        challengeAnnouncementHeadline,
        challengeAnnouncementEndDate,
        daysRemainingBeforeAnnouncementEnds }
    } = announcementDetails;

    if (loadingStatus) {
      return (
        <div>
          <h1 className='text-danger'><em>Please be patient as we upload the active challenge details...</em></h1>
        </div>
      )
    } else {
      const currentVideoCount = Object.values(announcementDetails.challengeVideos).length

      async function handleMakeChallengeActive() {
        const transferPayload = { oldType: "allUpcomingChallenges", newType: "allActiveChallenges", key: _challengeID, value: announcementDetails };

        try {
          const FStransferPayload = await dispatch(FStransferChallengeFromUpcomingToActive(transferPayload)); //new dispatch.
          navigate("/challenges/actives/all");
        } catch (err) {
          console.error({ err, errCode: err.code, errMessage: err.message });
          navigate("/");
        }
      }

      return (
        <div className='p-3'>
          <div style={{ backgroundColor: 'bisque' }} className='p-3'>
            <h3>_challengeID: {_challengeID}.</h3>
            <h5>owner: {_ownerID}.</h5>
            <h5>headline: {challengeAnnouncementHeadline}.</h5>
            <h5>This announcement will expire on {challengeAnnouncementEndDate}.</h5>
            <h5>Days remaining before this post ends: {daysRemainingBeforeAnnouncementEnds}.</h5>
            <div style={{ maxWidth: '25%', maxHeight: '25%', justifyContent: 'center' }}>
              <img src={imageLink} className='img-fluid' alt="Upcoming Challenge Pic." style={{border: '7px solid firebrick'}} />
            </div>
            <div className='videoGridContainer m-3 py-5'>
              {
                Object.values(challengeVideos).map(val => {
                  console.log({ val });
                  return <VideoCardComponent {...val} key={val._videoID}/>
                })
              }
            </div>
            {/*START: ADD MORE VIDEOS TO CHALLENGE. */}

            {
              addMoreVideos && <AllVideosComponent challengeVideos={challengeVideos} />
            }

            {
              (currentUser && currentUser._userID)
              &&
              <div className="d-grid gap-2"> 
                {
                  addMoreVideos?
                  (currentVideoCount > challengeVideosCount) ?
                  <AddVideoToChallengeForm /> : <button className="btn btn-success" type="button" onClick={() => setAddMoreVideos(!addMoreVideos)}> DONE ADDING VIDEOS. </button>
                  :
                  <button className="btn btn-danger" type="button" onClick={() => setAddMoreVideos(!addMoreVideos)}> ADD MORE VIDEOS TO THIS CHALLENGE!!! </button> 
                }
              </div>
              
            }       
            {/* END: ADD MORE VIDEOS TO CHALLENGE. */}
          </div>
          {
            currentUser.username === "admin"
            &&
            <div className="d-grid gap-2">
              <button className="btn btn-danger" type="button" onClick={handleMakeChallengeActive}>Make This Challenge Active!!!</button>
            </div>
          }        
        </div>
      )
    }
   
  }
  else {
    return (
      <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>
        <Alert color='danger'><h1>SORRY... THERE IS <span style={{ textDecoration: 'underline' }}><em>NO</em></span> _challengeID of {_challengeID}!!!</h1></Alert>
        <Link to="/"><h1 className='text-danger'>GO BACK TO THE HOME PAGE.</h1></Link>
      </div>
    )
  }  
}

export default memo(ChallengeAnnouncementDetails);



